import { getConfig } from "./config";

const createUrl = (path, params = {}) => {
  const config = getConfig();
  const url = new URL(path, config.apiUrl);
  
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });
  
  return url.toString();
};

export const fetchQuote = async (path, params) => {
  const sdkConfig = getConfig();
  const url = createUrl(path, params);
  
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), sdkConfig.timeout);
    
    const response = await fetch(url, {
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Request timeout');
    }
    throw new Error(error.message || "API request to get quote failed!");
  }
};